import { Box, Input, Typography } from "@mui/joy";
import { useEffect, useState, useRef } from "react";
import { debounce } from "lodash";
import { Palette } from "lucide-react";

interface IChimneyColor {
    value: string | null;
    onChange: (value: string) => void;
    loading?: boolean;
}

export function ChimneyColor(props: IChimneyColor) {
    const { value, onChange, loading } = { ...props };
    const [chimneyColor, setChimneyColor] = useState<string>(value || "");

    const debouncedOnChange = useRef(
        debounce((newValue: string) => {
            onChange(newValue);
        }, 500)
    ).current;

    const handleUpdate = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = event.target.value;
        setChimneyColor(newValue);
        debouncedOnChange(newValue);
    };

    useEffect(() => {
        setChimneyColor(value || "");
    }, [value]);

    useEffect(() => {
        return () => {
            debouncedOnChange.cancel();
        };
    }, [debouncedOnChange]);

    return (
        <Box flex={1}>
            <Typography level="body-sm" sx={{ fontWeight: "md", mb: 0.5 }}>
                Chimney Color
            </Typography>
            <Input
                placeholder="Enter chimney color"
                value={chimneyColor}
                onChange={handleUpdate}
                disabled={loading}
                startDecorator={<Palette size={16} />}
                sx={{ width: "100%" }}
            />
        </Box>
    );
}
